export const EVENTS = {
	ENTITY_SELECTED: 'ENTITY_SELECTED'
}